<div>
  @for (model of coverageModels; track model) {
    <div class="coverage-item-container">
      <ol class="accordion">
        <ds-accordion-category [htmlTitle]="true" [showIcon]="false">
          <div class="accordion-title" title>
            <div class="coverage-title">{{ model.coverage.description }}</div>
            @if (!hideTermDescription) {
              @if (!!model.coverage.showRejected) {
                <div class="coverage-details">
                  <strong>Rejected</strong>
                </div>
              } @else {
                @for (limitTerm of model.coverage.limitTerms | perPersonFirst; track limitTerm) {
                  <div class="coverage-details">
                    @if ((limitTerm | term: true : format)?.value; as limitValue) {
                      <div class="coverage-amount" data-cy="coverageAmount">
                        {{ limitValue }}
                      </div>
                    }
                    @if ((limitTerm | term: true : format)?.description; as limitDescription) {
                      <div class="coverage-description" data-cy="coverageDescription">
                        {{ limitDescription }}
                      </div>
                    }
                  </div>
                }
                @for (
                  deductibleTerm of model.coverage.deductibleTerms | perPersonFirst;
                  track deductibleTerm
                ) {
                  <div class="coverage-details" data-cy="coverageDetails">
                    @if ((deductibleTerm | term: true : format)?.value; as deductibleValue) {
                      <div class="coverage-amount" data-cy="coverageAmount">
                        {{ deductibleValue }}
                      </div>
                    }
                    @if (
                      (deductibleTerm | term: true : format)?.description;
                      as deductibleDescription
                    ) {
                      <div class="coverage-description" data-cy="coverageDescription">
                        {{ deductibleDescription }}
                      </div>
                    }
                  </div>
                }
              }
            }
          </div>
          <!-- <p class="coverage-text" data-cy="coverageText">
          {{ model.clickTipContent?.text }}
        </p> -->
        </ds-accordion-category>
      </ol>
    </div>
  }
  <div class="service-add-ons">
    @if (additionalCoverages.length) {
      <div class="service-add-ons-header" data-cy="additionalCoveragesHeader">
        Additional Coverages
      </div>
    }
    <ul>
      @for (additionalCoverage of additionalCoverages; track additionalCoverage) {
        <li class="pad-top-10 icon-complete discount">
          <span class="list" data-cy="additionalCoverageDescription">{{
            additionalCoverage.description
          }}</span>
        </li>
      }
    </ul>
  </div>
</div>
